module.exports = __webpack_public_path__ + "img/slide1_mobile.fa286c1b.jpg";